var m = require('mithril');
var alerts = require('../../layout/components/alerts');
var downloadFile = require('../../layout/components/downloadFile');

function getLocalTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/New_York';
  } catch (e) {
    return 'America/New_York';
  }
}

function getAssetId(assetRid) {
  if (!assetRid) {
    return '';
  }
  return String(assetRid).replace(/^#/, '');
}

function calibrationFieldLabel(fieldName) {
  var labels = {
    offset: 'Offset',
    foundAs: 'Found As',
    sourceReference: 'Source Reference',
    leftAs: 'Left As'
  };
  return labels[fieldName] || fieldName;
}

function normalizeDownloadErrorMessage(message) {
  var invalidFieldMatch = message && message.match(/^Calibration (offset|foundAs|sourceReference|leftAs) must be a valid number$/);
  if (invalidFieldMatch) {
    return 'Calibration ' + calibrationFieldLabel(invalidFieldMatch[1]) + ' is missing or not numeric. Edit the calibration and save numeric readings before downloading the report.';
  }
  return message;
}

function showDownloadError(error) {
  var message = normalizeDownloadErrorMessage(error && error.message ? error.message : 'Calibration report download failed');
  alerts.vm.add({ detail: message });
  m.redraw();
}

function downloadCalibrationReport(assetRid) {
  var assetId = getAssetId(assetRid);
  if (!assetId) {
    showDownloadError(new Error('Calibration report download failed'));
    return Promise.resolve();
  }

  return downloadFile('/api/v1/asset/' + assetId + '/certexport?' + m.buildQueryString({
    timezone: getLocalTimezone()
  })).catch(function (error) {
    showDownloadError(error);
  });
}

module.exports = downloadCalibrationReport;
